import { AppBar, Toolbar } from '@mui/material'
import { ModalCloseButton } from '../Modal'

export const DialogAppBar = ({
    handleClose,
    children,
}: {
    children?: JSX.Element
    handleClose: () => void
}) => {
    return (
        <AppBar
            sx={{
                position: 'relative',
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
                // height: '5vh',
            }}
        >
            <Toolbar sx={{ px: 3, pt: 1  }}>
                {!!children ? null : <div style={{ flex: 1 }} />}
                <ModalCloseButton
                    edge="start"
                    aria-label="close"
                    onClick={handleClose}
                />
                {children}
            </Toolbar>
        </AppBar>
    )
}
